import React from 'react'
import type { PopoverProps as MuiPopoverProps } from '@material-ui/core/Popover'
import MuiPopover from '@material-ui/core/Popover'

export type PopoverProps = MuiPopoverProps

const Popover = React.forwardRef<HTMLDivElement, PopoverProps>(function Popover(props, ref) {
  return <MuiPopover ref={ref} {...props} />
})

export default Popover
